import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";

import { FAQ_ITEMS } from "./faqItems";

export function FAQSection() {
  const { t } = useTranslation("landing");

  return (
    <section
      id="faq"
      className="bg-background py-20 sm:py-24 lg:py-28"
      aria-labelledby="faq-heading"
    >
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.25em] text-primary">
            {t("faq.eyebrow")}
          </p>
          <h2
            id="faq-heading"
            className="mt-4 font-serif text-4xl font-semibold leading-[1.1] tracking-[-0.04em] text-foreground sm:text-5xl lg:text-6xl"
          >
            {t("faq.heading")}
          </h2>
        </div>
        <div className="mt-12 divide-y divide-border rounded-3xl border border-border bg-card shadow-sm">
          {FAQ_ITEMS.map((id) => (
            <details
              key={id}
              className="group p-6 first:rounded-t-3xl last:rounded-b-3xl open:bg-muted/30"
            >
              <summary className="flex cursor-pointer list-none items-center justify-between gap-4 text-start text-lg font-semibold text-foreground">
                {t(`faq.items.${id}.question`)}
                <ArrowRight
                  className="h-5 w-5 shrink-0 transition-transform group-open:rotate-90 rtl:scale-x-[-1]"
                  aria-hidden="true"
                />
              </summary>
              <p className="mt-4 text-base leading-7 text-muted-foreground">
                {t(`faq.items.${id}.answer`)}
              </p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

export const FaqSection = FAQSection;
export default FAQSection;
